import React from 'react';
import { NavLink } from 'react-router-dom';

interface SubNavItem {
  label: string;
  path: string;
}

interface SubNavProps {
  items: SubNavItem[];
}

const SubNav: React.FC<SubNavProps> = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="w-full bg-white border-b border-gray-100 sticky top-20 z-40">
      <div className="container mx-auto px-4 md:px-8 flex justify-center md:justify-start space-x-8">
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end
            className={({ isActive }) =>
              `py-4 font-heading text-xs uppercase tracking-widest border-b-2 transition-colors ${
                isActive
                  ? 'border-black text-black'
                  : 'border-transparent text-gray-400 hover:text-black'
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default SubNav;
